export default __webpack_public_path__ + "static/media/loading.94d2efbb.gif";